import { render } from "./ContactDialog.vue?vue&type=template&id=953ce51c"
import script from "./ContactDialog.vue?vue&type=script&lang=js"
export * from "./ContactDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__